import { render, staticRenderFns } from "./AppCardCrud.vue?vue&type=template&id=5dc550c8&scoped=true&"
import script from "./AppCardCrud.vue?vue&type=script&lang=js&"
export * from "./AppCardCrud.vue?vue&type=script&lang=js&"
import style0 from "./AppCardCrud.vue?vue&type=style&index=0&id=5dc550c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc550c8",
  null
  
)

component.options.__file = "AppCardCrud.vue"
export default component.exports